import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  Form,
  Input,
  Label,
  Row,
  FormFeedback
} from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import { isEmpty } from "lodash";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import "react-rangeslider/lib/index.css"
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  updateAbout as onUpdateAbout,
  getAbout as onGetAbout,
} from "store/contacts/actions";
import toastr from 'toastr'; 
import 'toastr/build/toastr.min.css'; 

import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { CKEditor } from '@ckeditor/ckeditor5-react'
import { Base64 } from 'js-base64';

const EcommerceAddProduct = () => {
  document.title = "Hakkımızda Bilgileri | Bee Education B2B Paneli";

  const dispatch = useDispatch();

  const [getContactEdit, setContactEdit] = useState(null);
  const [getHtmlDataLong, setHtmlDataLong] = useState(null);
  const [getHtmlDataKVKK, setHtmlDataKVKK] = useState(null);

  const showToast= async (type) => {
    let ele = null
    let message = "";
  
     if(type == true){
       ele = "success"
       message = "Başarıyla güncellendi."
    } else{
       ele = "error"
       message = "Hata oluştu"
    };
    
    // ... (Toastr ayarları aynen kalıyor) ...
    
    toastr.options = {
      positionClass: "toast-top-right",
      timeOut: 5000,
      extendedTimeOut: 1000,
      closeButton: true,
      debug: false,
      progressBar: true,
      preventDuplicates: false,
      newestOnTop: true,
      showEasing: "swing",
      hideEasing: "linear",
      showMethod: "fadeIn",
      hideMethod: "fadeOut",
      showDuration: 300,
      hideDuration: 1000
    };
  
    if (ele === "info") toastr.info(message, "Bilgi");
    else if (ele === "warning") toastr.warning(message, "Uyarı");
    else if (ele === "error") toastr.error(message, "Hata");
    else toastr.success(message, "Başarılı");
  }

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      title: (getContactEdit && getContactEdit.Company_Name) || '',
      // Adres ve Telefon değerlerini state'den almaya devam ediyoruz ki veri kaybı olmasın,
      // ama ekranda inputları gizlediğimiz için kullanıcı değiştiremeyecek.
      adress:(getContactEdit && getContactEdit.Company_Adress) || '',
      phoneNumber:(getContactEdit && getContactEdit.Company_TelephoneNumber) || '',
      faxNumber:(getContactEdit && getContactEdit.Company_FaxNumber) || '',
      webAdress:(getContactEdit && getContactEdit.Company_WebAdress) || '',
    },
    validationSchema: Yup.object({
      title: Yup.string().required("Lütfen Başlık Giriniz")
    }),
    onSubmit: (values) => {

      const updateOrder = {
        ID: users ? users[0].ID : 0,
        Company_Name:values.title,
        // Eğer bu alanları tamamen boş göndermek (sıfırlamak) isterseniz aşağıdaki gibi "" gönderebilirsiniz.
        // Mevcut haliyle hidden input mantığında eski veriyi korur veya boşsa boş gider.
        Company_Adress: values.adress, 
        Company_TelephoneNumber: values.phoneNumber,
        Company_FaxNumber:values.faxNumber,
        Company_WebAdress:values.webAdress,
        Company_About: Base64.encode(getHtmlDataLong),
        About_KVKK: Base64.encode(getHtmlDataKVKK),
      };
      
      dispatch(onUpdateAbout(updateOrder));
      showToast(true)
      dispatch(onGetAbout());
    },
  });

  const { users } = useSelector(state => ({
    users: state.contacts.about,
  }));

  useEffect(() => {
    if (users && !users.length) {
      dispatch(onGetAbout());
    }
  }, [dispatch, users]);

  useEffect(() => {
    if(users.length > 0){
      setContactEdit(users[0]);

      if(users[0].About_KVKK != null){
        setHtmlDataKVKK(Base64.decode(users[0].About_KVKK))
      }
      if(users[0].Company_About != null){
        setHtmlDataLong(Base64.decode(users[0].Company_About))
      }
    }
  }, [users]);

  useEffect(() => {
    if (!isEmpty(users)) {
      setContactEdit(users[0]);
    }
  }, [users]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title="Yönetim" breadcrumbItem="Hakkımızda Bilgileri" />

          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <CardTitle>Hakkımızda Bilgileri</CardTitle>

                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <Row>
                      {/* BAŞLIK ALANI (KALDI) */}
                      <div className="mb-3">
                        <Label htmlFor="productname">Başlık</Label>
                        <Input
                          id="title"
                          name="title"
                          type="text"
                          className="form-control"
                          placeholder="Başlık"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.title || ""}
                          invalid={
                            validation.touched.title && validation.errors.title ? true : false
                          }
                        />
                        {validation.touched.title && validation.errors.title ? (
                          <FormFeedback type="invalid">{validation.errors.title}</FormFeedback>
                        ) : null}
                      </div>

                      {/* TELEFON VE ADRES ALANLARI GİZLENDİ
                          İhtiyaç duyulursa yorum satırları kaldırılarak geri getirilebilir.
                      */}

                      {/* <div className="mb-3">
                        <Label htmlFor="productname">Telefon</Label>
                        <Input
                          id="phoneNumber"
                          name="phoneNumber"
                          type="text"
                          className="form-control"
                          placeholder="Telefon Numarası"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.phoneNumber || ""}
                        />
                      </div>

                      <div className="mb-3">
                        <Label htmlFor="productname">Adres</Label>
                        <Input
                          id="adress"
                          name="adress"
                          type="text"
                          className="form-control"
                          placeholder="Adres"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.adress || ""}
                        />
                      </div> 
                      */}

                      {/* HAKKIMIZDA ALANI (KALDI) */}
                      <div className="mb-3">
                              <Label className="form-label">Hakkımızda </Label>
                              <div className="ck-editor-container">
                                <CKEditor
                                  editor={Editor}
                                  data={getHtmlDataLong}
                                  onReady={editor => {
                                    console.log('Hakkımızda Editor hazır!', editor);
                                  }}
                                  onChange={(event, editor) => {
                                    const data = editor.getData();
                                    setHtmlDataLong(data)
                                  }}
                                />
                              </div>
                            </div>

                            {/* KVKK ALANI (KALDI) */}
                            <div className="mb-3">
                              <Label className="form-label">KVKK</Label>
                              <div className="ck-editor-container">
                                <CKEditor
                                  editor={Editor}
                                  data={getHtmlDataKVKK}
                                  onReady={editor => {
                                    console.log('KVKK Editor hazır!', editor);
                                  }}
                                  onChange={(event, editor) => {
                                    const data = editor.getData();
                                    setHtmlDataKVKK(data)
                                  }}
                                />
                              </div>
                            </div>

                    </Row>
                    <div className="d-flex flex-wrap gap-2">
                      <Button type="submit" color="primary" className="btn ">
                        Kaydet
                      </Button>
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default EcommerceAddProduct